class CustomerLabels {

  constructor(currentUserBasePath, apiClient) {

    this.basePath = `${currentUserBasePath}/customer-labels`;
    this.apiClient = apiClient;

  }

  async createCustomerLabel(label) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, label);

  }

  async getCustomerLabelsByQueryOptions(queryOptions = {}) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async updateCustomerLabelById(customerLabelId, label) {

    const path = `${this.basePath}/:customerLabelId`;

    return this.apiClient.put(path, { customerLabelId }, {}, label);

  }

  async deleteCustomerLabelById(customerLabelId) {

    const path = `${this.basePath}/:customerLabelId`;

    return this.apiClient.delete(path, { customerLabelId }, {});

  }

}

export default CustomerLabels;